import React from 'react';
import './AdminTableQuizes.scss';
import TableQuizes from './TableQuizes/TableQuizes';
import { openAddInputFormsForQuizes  } from '../../../adminSlice';

export default class AdminTableQuizes extends React.Component {
    constructor(props) {
        super(props);

        this.onAdd = this.onAdd.bind(this);
    }

onAdd() {
    const { dispatch } = this.props;

    dispatch(openAddInputFormsForQuizes());

}
    render() {
        let style;
            
            if (this.props.adminState.selectedSubCategory) {
               
                    style = ''
                } else {
                    style = 'disabled'
                }

        const { dispatch} = this.props;
        return (
            
            <div className="AdminTableQuizes">
                   <p className='tableName'>Список тестов {this.props.adminState.selectedSubCategory} подкатегории</p>

                   <TableQuizes 
                   handleAdminQuizesView={this.props.handleAdminQuizesView}
                   dispatch={dispatch}
                   onClickQuiz={this.props.onClickQuiz}
                   data={this.props.adminState.dataQuizesId}
                  
                   />

                    <button className='addButton' onClick={this.onAdd}  disabled={style}>{/*<i className="fas fa-plus"></i>*/}</button>

            </div>
        )
    }
}